// extracted by mini-css-extract-plugin
module.exports = {"create":"styles_create__ED-RF"};